<template>
  <div class="CycleDistribution mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/CD001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('leftNav.navTwelve')}}</h1>
              <div style="float:right;display:flex;align-items:center;">
                <label style="margin-right:10px;font-size:12px;">{{$t('StepCycleTime.labelTitle1')}}</label>
                <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
              </div>
            </div>
            <div class="tableWrap">
              <div style="text-align:right">
                <el-button v-if="this.$store.state.authority.PageDownload.show" @click="exportBnt" class="export" icon="el-icon-download">{{$t('ReloadingStatistics.export')}}</el-button>
              </div>
              <el-tabs type="border-card" v-model="tabIndex" @tab-click="getTableData()">
                <el-tab-pane :label="$t('CycleDistribution.tabtitle')" :name="'1'">
                  <!-- 天表格 -->
                  <div v-if="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                  <el-table
                    :data="tableData"
                    border
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                    style="width: 100%"
                    v-else>
                    <el-table-column
                      :label="$t('CycleDistribution.tableTitle1')"
                      width="130">
                      <template slot-scope="scope">
                        <span>{{scope.row.startTime | formatDate}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('CycleDistribution.tableTitle2')"
                      width="130">
                      <template slot-scope="scope">
                        <span>{{scope.row.endTime | formatDate}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="total"
                      :label="$t('CycleDistribution.tableTitle3')"
                      width="100">
                    </el-table-column>

                    <el-table-column
                      v-for="(item,index) in tableTile"
                      :key="index"
                      min-width='180'
                      class-name='merge'
                      :label='item.label'
                      >
                      <template slot-scope="scope">
                        <span class="tableCell">{{scope.row[item.prop1]}}</span>
                        <span class="tableCell" v-if="scope.row[item.prop2]!== null">{{scope.row[item.prop2]}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="`${$t('CycleDistribution.tableTitle4')} (++++)`"
                      width="110">
                      <template slot-scope="scope">
                        <span>{{scope.row.checkCacul}}%</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 分页器 -->
                  <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    :total="totalPage"
                    :current-page='nowPage'
                    @current-change="handleCurrentChange">
                  </el-pagination>
                </el-tab-pane>
                <el-tab-pane :label="$t('CycleDistribution.tabtitle2')" :name="'2'">
                  <!-- 班组表格 -->
                  <div v-if="noMachine" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
                  <el-table
                    :data="tableDataShift"
                    border
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                    style="width: 100%"
                    v-else>
                    <el-table-column
                      prop="currentShift"
                      :label="$t('CycleDistribution.tabtitle2')"
                      width="60">
                    </el-table-column>
                    <el-table-column
                      :label="$t('CycleDistribution.tableTitle1')"
                      width="130">
                      <template slot-scope="scope">
                        <span>{{scope.row.startTime | formatDate}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="$t('CycleDistribution.tableTitle2')"
                      width="130">
                      <template slot-scope="scope">
                        <span>{{scope.row.endTime | formatDate}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="total"
                      :label="$t('CycleDistribution.tableTitle3')"
                      width="100">
                    </el-table-column>
                    <el-table-column
                      v-for="(item,index) in tableTile"
                      :key="index"
                      min-width='180'
                      class-name='merge'
                      :label='item.label'
                      >
                      <template slot-scope="scope">
                        <span class="tableCell">{{scope.row[item.prop1]}}</span>
                        <span class="tableCell" v-if="scope.row[item.prop2]!== null">{{scope.row[item.prop2]}}%</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="`${$t('CycleDistribution.tableTitle4')} (++++)`"
                      width="110">
                      <template slot-scope="scope">
                        <span>{{scope.row.checkCacul}}%</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!-- 分页器 -->
                  <el-pagination
                    class="pagination"
                    background
                    layout="prev, pager, next"
                    :total="totalPageShift"
                    :current-page='nowPageShift'
                    @current-change="handleCurrentChangeShift">
                  </el-pagination>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
    
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
// import { Loading } from 'element-ui'

export default {
  name: 'CycleDistribution',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [Number(this.$store.state.defaultFactoryId),Number(this.$store.state.defaultId)],
      fullscreenLoading: false,
      // 表格数据
      tableData:[],
      // 班组表格数据
      tableDataShift:[],
      // 分页
      nowPage: 1,
      totalPage: null,
      // 班组分页
      nowPageShift: 1,
      totalPageShift: null,
      tableTile:[
        {label: '', prop1: 'groupOneNum', prop2: 'groupOnePercentage'},
        {label: '', prop1: 'groupTwoNum', prop2: 'groupTwoPercentage'},
        {label: '', prop1: 'groupThreeNum', prop2: 'groupThreePercentage'},
        {label: '', prop1: 'groupFourNum', prop2: 'groupFourPercentage'},
        {label: '', prop1: 'groupFiveNum', prop2: 'groupFivePercentage'},
        {label: '', prop1: 'groupSixNum', prop2: 'groupSixPercentage'},
      ],
      // 选中的tab name值
      tabIndex:"1",
      noMachine:true
    }
  },
  beforeMount(){
    this.$store.commit('toLogin')
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getManiceList()
    this.getTableData()
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    },
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
  },
  filters: {
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'MM-dd hh:mm')
    }
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[1]=value
      this.machineChange()
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(res.data.options !==undefined && res.data.options.length > 0 ){
            _this.noMachine=false
            if(localStorage.getItem('isMarketAccount') === '1') {
              _this.$store.commit('marketAccount',res.data.options)
            }
            _this.options = res.data.options
          }else{
            _this.options = res.data.options
            _this.noMachine=true
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    machineChange(){
      this.nowPage = 1
      this.nowPageShift = 1
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.nowPage = val
      this.getTableData()
    },
    handleCurrentChangeShift (val) {
      this.nowPageShift = val
      this.getTableData()
    },
    getTableData(){
      let _this = this
      this.fullscreenLoading = true
      var nPage = 1
      if(_this.tabIndex === '1'){
        nPage = _this.nowPage
      }else{
        nPage = _this.nowPageShift
      }
      this.axios({
        method: 'post',
        url: '/url/getCycleDistributionData',
        params: {
          machineId: _this.machineID[1],
          disType: _this.tabIndex,
          pageNum: nPage,
          pageSize: 10,
          language: _this.$store.state.lang
        }
      }).then(function (res) {
        if (res.data.success === 'true') {
          if('cycleDistributionTitle' in res.data){
            for (const [index, item] of _this.tableTile.entries()) {
              item.label = res.data.cycleDistributionTitle[index]
            }
            if(_this.tabIndex === '1'){
              _this.tableData = res.data.cycleDistributionList
              _this.totalPage = res.data.total
            }else{
              _this.tableDataShift = res.data.cycleDistributionList
              _this.totalPageShift = res.data.total
            }
          }else{
            _this.totalPage = res.data.total
            _this.totalPageShift = res.data.total
          }
        } else {
          _this.$message.error(_this.$t('CycleDistribution.error1'))
        }
        _this.fullscreenLoading = false
      })
    },
    exportBnt(){
      let type
      this.tabIndex === '1'?type=1:type=2
      var pagenum = type===1?this.nowPage:this.nowPageShift
      if(type=='1'){
        if(this.tableData == null || this.tableData.length == 0){
          this.$message.error(this.$t('gantt.error'));
        }else{
          let signTime = new Date().getTime()
          this.$store.commit('nowsign', signTime)
          let urlData = `?machineId=${this.machineID[1]}&pageNum=${pagenum}&pageSize=10&language=${this.$store.state.lang}&factoryId=${this.machineID[0]}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&disType=${type}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`
          window.open('/url/excelExportCycleDistributionData' + urlData, '_blank')
        }
      }else{
        if(this.tableDataShift == null || this.tableDataShift.length == 0){
          this.$message.error(this.$t('gantt.error'));
        }else{
          let signTime = new Date().getTime()
          this.$store.commit('nowsign', signTime)
          let urlData = `?machineId=${this.machineID[1]}&pageNum=${pagenum}&pageSize=10&language=${this.$store.state.lang}&factoryId=${this.machineID[0]}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&disType=${type}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`
          window.open('/url/excelExportCycleDistributionData' + urlData, '_blank')
        }
      }
      
    }
  }
}
</script>
<style scoped>
.CycleDistribution{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.tableWrap{
  box-sizing: border-box;
  margin: 20px 15px;
  padding-bottom: 30px;
}
.tableCell{
  display: inline-block;
  width: 50%;
  padding: 0 7px;
  box-sizing: border-box;
}
.tableCell:nth-child(1){
  border-right: 1px solid #ebeef5
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.export{
  width: 100px;
  margin-bottom: 15px;
}
.noMachineTitle{
    color:#909399;
    line-height: 100px;
    text-align: center;
}
</style>

